import TypographyOverflow, {
	type TypographyOverflowProps,
} from '@liquidweb-dev/undercurrent/TypographyOverflow';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

const Label = ({ sx, ...rest }: TypographyOverflowProps) => (
	<TypographyOverflow
		variant="label-lg"
		sx={combineSx(
			{
				color: ({ vars }) => vars.palette.uc.text.weak,
			},
			sx,
		)}
		{...rest}
	/>
);

export default Label;
